// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".followListWrap[data-v-562e23bc]{width:100%;height:100%}.targetListWrap[data-v-562e23bc]{position:relative}", ""]);
// Exports
module.exports = exports;
